import { APP_STAGES } from '@/api/stageGrants';
import type { StageGrantChanges } from '@/api/stageGrants';

// 재시도가 필요한 Stage 저장(응답 불명·BigQuery 반영 실패)만 담는다. 제공 계층 동기화 상태는 더 이상 추적하지 않는다.
export type StageOperation = { id: string; body: StageGrantChanges; bqSyncFailed?: boolean };
const STORAGE_KEY = 'orbit.stage-operations.v1';

// 결과 불명인 저장 요청을 탭 세션에 보존한다. 자동 재저장은 하지 않는다.
export function readStageOperations(): Record<string, StageOperation> {
  try {
    const raw: unknown = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '{}');
    if (!raw || typeof raw !== 'object' || Array.isArray(raw)) return {};
    return Object.fromEntries(Object.entries(raw).filter(([email, value]) => {
      const operation = value as StageOperation;
      return operation && typeof operation.id === 'string'
        && operation.body?.email === email && Array.isArray(operation.body?.changes)
        && operation.body.changes.every(change => change && APP_STAGES.includes(change.stage)
          && [null, 'viewer', 'editor'].includes(change.level))
        && (operation.bqSyncFailed === undefined || typeof operation.bqSyncFailed === 'boolean');
    }));
  } catch {
    return {};
  }
}

export function storeStageOperations(operations: Record<string, StageOperation>) {
  try { sessionStorage.setItem(STORAGE_KEY, JSON.stringify(operations)); }
  catch { /* 저장소 비활성 환경에서도 현재 화면의 상태 추적은 유지한다. */ }
}
